import type { ConeCrusherCSUnitInfoDataMapInterface } from './unitInfoData';

/**
 * Get variable D
 * @param modelName Model name of CS Crusher
 * @param unitInfoData Unit info data for CS Crusher
 */
export const getD = (
  modelName: string,
  unitInfoData: ConeCrusherCSUnitInfoDataMapInterface,
) => {
  return unitInfoData[modelName].d;
};

export const getRFO = (
  modelName: string,
  concaveName: string,
  unitInfoData: ConeCrusherCSUnitInfoDataMapInterface,
) => {
  return unitInfoData[modelName]?.concaves[concaveName].rfo;
};

export const CSCrusherGetMaxCSS = (
  modelName: string,
  concaveName: string,
  mantleName: string,
  selectedThrow: number,
  unitInfoData: ConeCrusherCSUnitInfoDataMapInterface,
) => {
  const nss =
    unitInfoData[modelName]?.concaves[concaveName]?.mantles[mantleName]?.nss;
  const angleExist = unitInfoData[modelName]?.concaves[concaveName]?.angle;
  if (angleExist) {
    const oil = unitInfoData[modelName].oil;
    return Math.ceil(
      nss - oil * Math.sin((angleExist * Math.PI) / 180) - selectedThrow / 2,
    );
  } else {
    return 0;
  }
};

export const motorPower = (
  modelName: string,
  concaveName: string,
  selectedThrow: number,
  unitInfoData: ConeCrusherCSUnitInfoDataMapInterface,
) => {
  const basicPower = unitInfoData[modelName]?.concaves[concaveName].basicPower;
  const diameter = unitInfoData[modelName].d;
  const idlePower = unitInfoData[modelName].idlePower;
  return Math.round(
    (basicPower * (0.667 * selectedThrow + 0.2 * diameter) + idlePower) / 1.1,
  );
};

export const nominalCapacity = (
  modelName: string,
  concaveName: string,
  css: number | undefined,
  selectedThrow: number,
  unitInfoData: ConeCrusherCSUnitInfoDataMapInterface,
) => {
  const basicCapacity =
    unitInfoData[modelName]?.concaves[concaveName].basicCapacity;
  if (css) {
    const d = getD(modelName, unitInfoData);
    return Math.round(
      basicCapacity *
        (0.04 * css + 1) *
        0.6 *
        d *
        ((0.7 * selectedThrow) / (0.6 * d) + 0.3),
    );
  }
};

export const maxFeedF100 = (
  modelName: string,
  concaveName: string,
  unitInfoData: ConeCrusherCSUnitInfoDataMapInterface,
) => {
  return Math.round(getRFO(modelName, concaveName, unitInfoData) * 1.1);
};

export const maxFeedF90 = (
  modelName: string,
  concaveName: string,
  unitInfoData: ConeCrusherCSUnitInfoDataMapInterface,
) => {
  return Math.round(getRFO(modelName, concaveName, unitInfoData) * 0.73);
};
